define(
    'viewmodels/secured/libraries/dashboard',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModel, dataProvider, i19n) {
        var vm = new ViewModel(
        {
            id: '',
            notify: {},
            reload: {},
            comboClick: {},
            i19n: i19n,

            documentCount: ko.observable(),
            lastAccessedString: ko.observable(''),
            lists: ko.observable(''),

            dashboardData : {},

            pieData: [{ category: '', value: '' }],
            barData: { axis: [], data: [] },

            isNoDocument: ko.observable(false)

        });

        vm.activate = function () {
            var self = this;

            return dataProvider.libraries
                .getDashboard(vm.id)
                .done(function (data) {
                    vm.dashboardData = data;
                })
                .fail(function (e) {
                    console.log(e);
                });
        };
        vm.attached = function () {
            var self = this;
            var data = vm.dashboardData;

            var c = _.chain(data.documentsByClass)
                    .map(function (itm) { return { category: itm.documentClass.replace('Document', ''), value: itm.documentCount }; })
                    .map(function (itm) { return { category: toFormalString(itm.category), value: itm.value }; })
                    .filter(function (itm) { return itm.value != "0"; })
                    .sortBy(function (itm) { return itm.category; })
                    .value();

            var d = _.chain(data.mostActiveUsers)
                    .map(function (itm) {return { person: itm.personDisplayName, count: itm.documentCount };})
                    .filter(function (itm) { return itm.count != "0"; })
                    .sortBy(function (itm) { return itm.count; })
                    .last(4)
                    .sortBy(function (itm) { return itm.person; })
                    .value();
            
            var lastAccess = data.lastAccessedString == null ? '' : data.lastAccessedString;
            //if (lastAccess == '') {
            //    lastAccess = lastAccess.replace('Days', '');
            //    lastAccess = (parseInt(lastAccess)).toLocaleString() + ' ' + i19n.to.days;         
            //}

            vm.documentCount(data.documentCount.toLocaleString());
            vm.lastAccessedString(lastAccess);
            vm.lists(data.listName == null ? i19n.to.no : data.listName);
            //c = [{ category: "Controlled", value: 140 }, { category: "Email", value: 200 }, {category: "Working", value: 100}];
            vm.pieData = c;                    
            vm.barData.axis = _.pluck(d, 'person');
            vm.barData.data = _.pluck(d, 'count');

            setWidgetData();

            vm.isNoDocument(data.documentCount == 0);
        };

        return vm;

        function setWidgetData() {
            var seriesColors = ['#82af6f', '#fee188', '#3a87ad'];

            $("#chartPie").kendoChart({
                theme: 'Bootstrap',
                title: { text: i19n.to.documentsbyclass, position: "bottom", font: '14px "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif' },
                legend: {
                    labels: {
                        font: '11px "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif'
                    },
                    position: "top"
                },
                seriesDefaults: {
                    //labels: {
                    //    template: "#= category # - #= kendo.format('{0:P}',percentage)#",
                    //    position: "outsideEnd",
                    //    visible: true,
                    //    background: "transparent"
                    //}
                },
                seriesColors: seriesColors,
                series: [
                {
                    type: "pie",
                    startAngle: 90,
                    data: vm.pieData
                }]
            });

            $("#chartBar").kendoChart({
                theme: 'Bootstrap',
                title: { text: i19n.to.mostactiveusers, position: "bottom", font: '14px "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif' },
                seriesDefaults: {
                    type: "column",
                    gap: 0.5
                },
                valueAxis: {
                    labels: {
                        font: '11px "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif'
                    },
                    //max: 100,
                    line: { visible: false },
                    minorGridLines: { visible: false }
                },
                categoryAxis: {
                    labels: {
                        font: '11px "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif'
                    },
                    categories: vm.barData.axis,
                    majorGridLines: { visible: false }
                },
                series: [{
                    data: vm.barData.data,
                    color: '#3a87ad'
                }]
            });
        }
        function toFormalString(s) {
            if (s == null || s.length == 0)
                return '';
            if (s.length > 1)
                return s.substr(0, 1).toUpperCase() + s.substr(1);

            return '';
        }
    }
);
